module.exports = __webpack_public_path__ + "static/media/IMG_3924.dc3cbbfb.JPG";